import { Div, FormStatus, Icon, P, Span } from '@dnb/eufemia';
import { check as CheckIcon, close as CloseIcon } from '@dnb/eufemia/icons';
import type { ReactNode } from 'react';

import style from './index.module.css';

type AdditionalInformationProps = {
  content: string;
  displayHelpText: boolean;
  value: boolean;
  statusMessage: ReactNode;
  codeBlock?: ReactNode;
};
export default function AdditionalInformation({
  codeBlock,
  content,
  displayHelpText,
  value,
  statusMessage,
}: AdditionalInformationProps) {
  return (
    <div className={style['Container']}>
      <div className={style['CardRow']}>
        <P>{content}</P>
        <div className="grid grid-cols-2 items-center gap-x-2">
          <Span lineHeight="small" right="small">
            {value ? (
              <Icon className={style['Checkmark']} icon={<CheckIcon />} />
            ) : (
              <Icon className={style['CloseIcon']} icon={<CloseIcon />} />
            )}
          </Span>
          <P>{value ? 'Yes' : 'No'}</P>
        </div>
      </div>
      {displayHelpText && !value && (
        <Div className={style['CodeBlock']} top="small">
          <FormStatus state="info">{statusMessage}</FormStatus>
          {codeBlock && (
            <>
              <P top="small">Example request</P>
              {codeBlock}
            </>
          )}
        </Div>
      )}
    </div>
  );
}
